var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgEditGates(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 9,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00ADB5",
    fillRule: "evenodd",
    d: "M7.615.423c0 .234-.19.423-.423.423H.423a.423.423 0 0 1 0-.846h6.77c.233 0 .422.19.422.423ZM6.487 2.68c0 .233-.19.422-.423.422H.424a.423.423 0 0 1 0-.846h5.64c.234 0 .423.19.423.423ZM4.23 4.936c0 .234-.189.423-.422.423H.423a.423.423 0 0 1 0-.846h3.385c.233 0 .423.19.423.423ZM3.667 7.192c0 .234-.19.423-.423.423H.424a.423.423 0 0 1 0-.846h2.82c.233 0 .423.19.423.423Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00ADB5",
    d: "M8.32 1.128c.233 0 .423.19.423.423 0 1.013.82 1.834 1.833 1.834a.423.423 0 0 1 0 .846 2.67 2.67 0 0 1-1.833-.726v2.841a1.833 1.833 0 1 1-.846-1.545V1.55c0-.233.19-.423.423-.423Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditGates);
export default __webpack_public_path__ + "static/media/edit-gates.821c2309c0085abc4fae19c2706bc84f.svg";
export { ForwardRef as ReactComponent };